<template>
  <KdsChip :live="true">
    <slot>Live</slot>
  </KdsChip>
</template>

<script setup lang="ts">
import KdsChip from '@/kds/primitives/KdsChip.vue';
</script>
